import moment from "moment"
export const process24Hour = h => {
    if(h > 12) return h - 12
    if(h === 0) return 12 
    return h
}

export const dateToYMD = date => `${date.getFullYear()}-${addZero(date.getMonth()+1)}-${addZero(date.getDate())}`

export const addZero = n => Number(n) < 10 ? `0${parseInt(n)}` : n.toString();

// int -> {hours:int,minutes:int,seconds:int}
export const secondsToTimeObj = seconds => {
  seconds = parseInt(seconds) || 0
  const hours = Math.floor(seconds/60/60)
  seconds -= hours*60*60
  const minutes = Math.floor(seconds/60)
  seconds -= minutes*60

  return {hours,minutes,seconds}
}

export function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    let month = now.getMonth() + 1; // Month is zero-based
    let day = now.getDate();
    let hours = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();

    // Padding zeros if needed
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
}


//converts a timestring to a time object {hour,min,p}
export const stringToTimeObject = (timestring,isTime24Hour) => {
	const splitTimestring = timestring.split(':')
	const HH = parseInt(splitTimestring[0])
	const m = splitTimestring[1]
	const p = HH >= 12 ? 'p' : 'a'
	const h = isTime24Hour ? HH : (
		//subtract 12 from all hours greater than 12
		HH > 12 ?
			HH - 12 :
			//if hour is 0 make it 12 AM 
			//else return hour
			(HH === 0 ? 12 : HH)
	)
	return { hour: h, min: m, p }
}

// converts date objects to time object {hour,min,p}
export const dateToTimeObj = (date,isTime24Hour=false) => {
    const h = date.getHours()
    const min = date.getMinutes()
    const hour = !isTime24Hour ? process24Hour(h) : h
    const p = h >= 12 ? 'p' : 'a'
    return ({hour,min,p})
}

//converts time object {hour,min,p} to a string value
export const getTimeString = (t,isTime24Hour) => {
    return isTime24Hour ? `${addZero(t.hour)}:${addZero(t.min)}:00` :
    // if 12 hour time then do AM vs PM logic
    t.p === 'p' ?
        //PM logic
        `${t.hour == '12' ? t.hour : parseInt(t.hour) + 12}:${addZero(t.min)}:00` :
        //AM logic
        `${t.hour == '12' ? '00' : addZero(t.hour)}:${addZero(t.min)}:00`
}

export const dateToAPIStandard = date =>(
    //get YYYY-MM-DD HH:MM:SS from date object
    `${
        date.getFullYear()+'-'+addZero(date.getMonth()+1)+'-'+addZero(date.getDate())
    } ${
        addZero(date.getHours())+':'+addZero(date.getMinutes())+':'+addZero(date.getSeconds())
    }`
)

// checks if an input time is MM:SS or SS
export const isStandardDuration = duration => (
    duration.split(':').reduce((carry,item)=>carry&&!isNaN(item),true) && duration.split(':').length <= 2 && Boolean(duration)
)

export const generateReadableStandardDuration = duration => {
    const split = duration.split(':')
    if(split.length === 1) return `${split[0]} seconds`
    if(parseInt(split[1]) === 0) return `${split[0]} minutes`
    return `${split[0]} minutes and ${split[1]} seconds` 
}

export const minuteDiff = (a,b)=>Math.floor(((a-b)/1000)/60)

/**
 * performs logic to make strings like
 * 9:30 AND also returns 9 instead of 9:00
 * do this to help condense the strings
 */
export const timeObjToStr = o => o.min ? `${o.hour}:${addZero(o.min)}` : o.hour

export const condensedTimeRange = (start,end)=>{
	const startTimeObj = dateToTimeObj(start)
	const endTimeObj = dateToTimeObj(end)
	if(start.p === end.p){
		return `${timeObjToStr(startTimeObj)} - ${timeObjToStr(endTimeObj)}${minuteDiff(end,start)<=30?'':endTimeObj.p}`
	}else{
		return `${timeObjToStr(startTimeObj)}${startTimeObj.p} - ${timeObjToStr(endTimeObj)}${minuteDiff(end,start)<=30?'':endTimeObj.p}`
	}
}

// function that sets date to 7 days before start of month
// of the date provided
export const startDateRange = (date) => {

  let startOfMonth = moment(date).startOf('month')
  const startDateObj = moment(startOfMonth).toDate();
  startDateObj.setDate(startDateObj.getDate() - 7)
  //month
  let mm = startDateObj.getMonth() + 1;
  //year
  let yyyy = startDateObj.getFullYear();
  // day
  let dd = startDateObj.getDate();

  if (mm < 10) { mm = `0${mm}`; }
  if (dd < 10) { dd = `0${dd}`; }
  // this will make sure to load in final days of month before input date
  let newDate = `${yyyy}-${mm}-${dd}`;
  return newDate;
}